import Snippet from '../../../../components/Snippet/Snippet'
import { rowColBg, columnColBg } from '../../../../assets/code-snippets/column/snip'

const ColumnBg = () => {
    return <div className="container fluid my-1" id="color">

        <div className="container xxl">
            <p className="text xl"><a className="link" href="#color">&#128279;</a>Cols default colors</p>
            <p className="text md">
                There a multiple ways to apply a default color to a specific <code>.col</code> or to
            multiple <code>cols</code> on one go, such as: </p>
            <div className="container md">
                <ul>
                    <li> <p className="text sm">add class <code>bg-</code> to a <code>.col</code></p> </li>

                    <Snippet code='<div class="col bg-dark"></div>' language='html' />

                    <li> <p className="text sm">add class <code>.color</code> next to <code>.row</code> or
                    <code>.column</code> </p> </li>

                    <Snippet code={rowColBg} language='html' />
                </ul>
            </div>
        </div>

        <div className="container md py-3">
            <Snippet code={columnColBg} language='html' />
        </div>

        <div className="container border border-dark px-2 py-5">
            <div className="row dark">
                <div className="col auto p-2 border-light">col</div>
                <div className="col auto p-2 border-light">col</div>
                <div className="col auto p-2 border-light">col</div>
            </div>
        </div>

    </div>
}
export default ColumnBg